import $axios from '@/axios-instance.js'

export const userService = {
  getListData,
  getAll,
  getAllInRole,
  getById,
  create,
  update,
  externalUpdate,
  delete: _delete,
  changePin,
  changePinAdmin
}

function getListData (filter, page) {
  return $axios.get(`${process.env.ROOT_API}/users`, { params: Object.assign({ currentPage: page }, filter) }).then(response => {
    return response.data
  })
}

function getAll () {
  return $axios.get(`${process.env.ROOT_API}/users/get-all`).then(response => {
    return response.data
  })
}

function getAllInRole (role) {
  return $axios.get(`${process.env.ROOT_API}/users/get-all-in-role/${role}`).then(response => {
    return response.data
  })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/users/${id}`).then(response => {
    return response.data
  })
}

function create (user) {
  return $axios.post(`${process.env.ROOT_API}/users`, user).then(response => {
    return response.data
  })
}

function update (user) {
  return $axios.put(`${process.env.ROOT_API}/users/${user.userId}`, user).then(response => {
    return response.data
  })
}

function externalUpdate (user) {
  console.log(user)
  return $axios.put(`${process.env.ROOT_API}/users/external-update`, user).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/users/${id}`).then(response => {
    return response.data
  })
}

function changePinAdmin (id, newPin) {
  return $axios.put(`${process.env.ROOT_API}/users/${id}/change-pin-admin`, { newPin }).then(response => {
    return response.data
  })
}

function changePin (newPin) {
  return $axios.put(`${process.env.ROOT_API}/users/change-pin`, { newPin }).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/user.service.js